import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import ButtonGroup from "@mui/material/ButtonGroup";
import { CsCfgObjectStubDebug } from "@plansoft-configuration-renderer/debug";
import { SubstructureInstanceButtonMapping } from "./InstanceButtons/SubstructureInstanceButtonMapping";
import { useSubstructureLayout } from "./useSubstructureLayout";
function stopPropagation(e) {
    // if this bubbles up, it can trigger accordion / list actions
    e.stopPropagation();
}
/**
 * Buttons for controlling the instance of a substructure
 * @param props
 * @returns
 */
export function SubstructureInstanceButtons(props) {
    const { instanceButtonOrder: instanceButtons } = useSubstructureLayout();
    const { substructure } = props;
    return (_jsxs(ButtonGroup, { onClick: stopPropagation, onMouseDown: stopPropagation, onMouseUp: stopPropagation, children: [instanceButtons.map((control) => {
                const ButtonComponent = SubstructureInstanceButtonMapping[control];
                if (!ButtonComponent) {
                    return _jsx(Fragment, {}, control);
                }
                return _jsx(ButtonComponent, { substructure: substructure }, control);
            }), _jsx(CsCfgObjectStubDebug, { substructure: substructure, chipSx: { my: 1 } })] }));
}
SubstructureInstanceButtons.displayName = "SubstructureInstanceButtons";
//# sourceMappingURL=SubstructureInstanceButtons.js.map